export default __webpack_public_path__ + "static/media/right.1debf504.jpg";